import ApplicationController from './application_controller';

// Live "Sign N sessions" / "Submit N claims" count for a form of checkboxes.
// Mounted on the form, it listens for any checkbox input that bubbles up — per-row
// toggles and the select-all master (which dispatches input events) — recounts the
// checked entries, updates the submit label, and disables submit at zero. The
// defaults match the sign-by-link page; other forms pass their own values:
//
//   data-selection-count-input-name-value="edi837_p_ids[]"
//   data-selection-count-idle-label-value="Submit selected claims"
//   data-selection-count-verb-value="Submit"
//   data-selection-count-singular-value="claim"
//   data-selection-count-plural-value="claims"
//   data-selection-count-busy-label-value="Submitting..."
//
// Server-side "select at least one" guard remains the backstop if JS doesn't run.
export default class extends ApplicationController {
  static targets = ['output', 'submit'];

  static values = {
    inputName: { type: String, default: 'entry_ids[]' },
    idleLabel: { type: String, default: 'Sign selected sessions' },
    verb: { type: String, default: 'Sign' },
    singular: { type: String, default: 'session' },
    plural: { type: String, default: 'sessions' },
    busyLabel: { type: String, default: 'Signing...' },
  };

  connect() {
    this.update();
  }

  update() {
    const count = this.element.querySelectorAll(`input[name="${this.inputNameValue}"]:checked`).length;

    if (this.hasOutputTarget) {
      this.outputTarget.textContent =
        count === 0
          ? this.idleLabelValue
          : `${this.verbValue} ${count} ${count === 1 ? this.singularValue : this.pluralValue}`;
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = count === 0;
    }
  }

  // Guard against a double-tap on the full-page (turbo: false) submit: disable
  // the button and show progress. The form still submits; this only blocks a
  // second POST. On a server-side validation failure the page re-renders and
  // connect() -> update() restores the button, so it can't get stuck disabled.
  submitting() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true;
    }
    if (this.hasOutputTarget) {
      this.outputTarget.textContent = this.busyLabelValue;
    }
  }
}
